import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  '&[data-hover="true"]:hover': {
    backgroundColor: theme.palette.coolGrey[100],
    borderColor: theme.palette.coolGrey[300],
    borderStyle: 'solid',
    borderWidth: 1,
    padding: theme.custom.spacing * 2 - 1,
  },
  '&:focus-within': {
    backgroundColor: theme.palette.coolGrey[100],
    borderColor: theme.palette.coolGrey[300],
    borderStyle: 'solid',
    borderWidth: 1,
    padding: theme.custom.spacing * 2 - 1,
  },
}));
